import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAdvertising } from '@/context/AdvertisingContext.jsx'
import { useConsent } from '@/context/ConsentContext.jsx'
import { observeNexoVitals } from '@/lib/nexoVitals.js'
import { clearAdDiagnostics, exportAdDiagnostics, recordAdDiagnostic, recordAdPerformanceGuard, recordAdVital, recordEligibleAdPageView } from '@/lib/adDiagnostics.js'

export default function AdvertisingDiagnostics() {
  const policy = useAdvertising()
  const { consent } = useConsent()
  const { key } = useLocation()
  // Unknown age is now UNSPECIFIED for ads, but analytics keeps its adult filter.
  const enabled = policy.eligible && !policy.mockEnabled && policy.reason === 'adult_contextual' && consent.analytics === 'granted'
  useEffect(() => {
    if (!enabled) { clearAdDiagnostics(); delete window.__visualgAdDiagnostics; return undefined }
    const receive = event => recordAdDiagnostic(event.detail)
    window.addEventListener('visualg:ad-lifecycle', receive)
    window.__visualgAdDiagnostics = { export: exportAdDiagnostics }
    const unobserve = observeNexoVitals(metric => recordAdVital(policy.pageFamily, metric))
    const error = () => recordAdPerformanceGuard(policy.pageFamily, 'client_error')
    window.addEventListener('error', error, true)
    window.addEventListener('unhandledrejection', error)
    let observer
    try {
      if (typeof PerformanceObserver === 'function' && PerformanceObserver.supportedEntryTypes?.includes('longtask')) {
        observer = new PerformanceObserver(list => list.getEntries().forEach(entry => recordAdPerformanceGuard(policy.pageFamily, 'longtask', entry.duration)))
        observer.observe({ type: 'longtask' })
      }
    } catch { /* Optional observer: older browsers retain lifecycle diagnostics. */ }
    return () => { window.removeEventListener('visualg:ad-lifecycle', receive); window.removeEventListener('error', error, true); window.removeEventListener('unhandledrejection', error); observer?.disconnect(); unobserve() }
  }, [enabled, policy.pageFamily])
  useEffect(() => { if (enabled) recordEligibleAdPageView(policy.pageFamily, key) }, [enabled, policy.pageFamily, key])
  return null
}
